export default "__VITE_ASSET__BN8FJylJ__"